export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ced143ea-8f7a-4b80-bca6-0994a0bedee9';
export const MODAL_CLOSE_SEC = 2.5;
